App.controller('HouseStartCtrl', ['$scope', '$sce', '$state', '$http', 'packageService', '$stateParams', '$timeout', function ($scope, $sce, $state, $http, packageService, $stateParams, $timeout) {
    $scope.stateParams = $stateParams;

    $scope.page = 'House_start';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Ubezpieczenie domu/mieszkania';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.dashboard';
    $scope.$emit('link', $scope.link);

    if ($scope.stateParams.choose && $scope.stateParams.prices) {
        $scope.choose = $scope.stateParams.choose;
        $scope.prices = $scope.stateParams.prices;
        $scope.summary = $scope.stateParams.summary;
        $scope.persons = $scope.stateParams.persons;
    } else {
        $scope.summary = 0;
    }

    $scope.allLength = 0;
    $scope.groupwidth = [];
    $scope.singleLength = [];

    $scope.next = function () {
        $state.go('root.house.start', {
            persons: $scope.persons,
            choose: $scope.choose,
            prices: $scope.prices,
            summary: $scope.summary
        });
    }

    $timeout(function() {
        if (!$('.menu.menu_6').hasClass('open')) {
            $('a[target=".menu_6"]').trigger('click');
        }
    }, 0);
}]);